import React from 'react';

import SummaryTable from 'src/views/components/SummaryTable';

const UserMappingSummary = ({ userMapping: { pd_email, pd_html_url, pd_displayname, jira_displayname, jira_email, jira_html_url } }) => {
  return (
    <SummaryTable>
      <tbody>
        <tr>
          <td>PagerDuty user</td>
          <td><a href={pd_html_url} target="_blank" rel="noopener noreferrer">{pd_displayname}</a></td>
        </tr>
        <tr>
          <td>PagerDuty email</td>
          <td>{pd_email}</td>
        </tr>
        <tr>
          <td>Jira user</td>
          <td><a href={jira_html_url} target="_blank" rel="noopener noreferrer">{jira_displayname}</a></td>
        </tr>
        <tr>
          <td>Jira email</td>
          <td>{jira_email}</td>
        </tr>
      </tbody>
    </SummaryTable>
  );
};

export default UserMappingSummary;
